import { forwardRef } from "react";

import {
  LogoBaird,
  LogoBairdMarkOnly,
  LogoBairdWordOnly,
} from "./logo.components";
import type { LogoVariants } from "./logo.styles";

/**
 * Warning: Keep these components in sync with their SVG counterparts:
 * - `<LogoBairdMarkOnly />` : `logo-baird-mark-only.svg`
 * - `<LogoBairdWordOnly />` : `logo-baird-word-only.svg`
 * - `<LogoBaird />` : `logo-baird.svg`
 */
const logoLayoutMap = {
  "mark-only": LogoBairdMarkOnly,
  "word-only": LogoBairdWordOnly,
  "mark-and-word": LogoBaird,
} as const;

export type LogoRef = React.ComponentRef<"svg">;

export interface LogoProps
  extends
    Omit<
      React.ComponentPropsWithoutRef<"svg">,
      "fill" | "width" | "height" | "viewBox" | "xmlns"
    >,
    LogoVariants {}

const Logo = forwardRef<LogoRef, LogoProps>(({ layout, ...props }, ref) => {
  const Comp = logoLayoutMap[layout ?? "mark-and-word"];
  return <Comp {...props} ref={ref} />;
});

Logo.displayName = "Logo";

export { Logo };
